const retryIntervalMs = 200;
const maxRetries = 150;

// Both tracker scripts load asynchronously — umami is appended on window load, fathom is deferred —
// so events fired while the app boots arrive before the global exists. Navigating the app tracks
// nothing, so a queued event cannot rely on a later event coming along to drain it.
export const createDeliveryQueue = <T>(
  deliver: (item: T) => void,
  isReady: () => boolean,
) => {
  const pending: T[] = [];
  let retryTimer: ReturnType<typeof setInterval> | undefined;
  let retries = 0;

  const stopRetrying = () => {
    clearInterval(retryTimer);
    retryTimer = undefined;
  };

  const flush = () => {
    if (!isReady()) {
      return;
    }

    while (pending.length) {
      try {
        deliver(pending.shift()!);
      } catch {
        // Tracking must never break the action the user actually took.
      }
    }

    stopRetrying();
  };

  return (item: T) => {
    pending.push(item);
    flush();

    if (!pending.length || retryTimer) {
      return;
    }

    retries = 0;
    retryTimer = setInterval(() => {
      flush();

      if (++retries >= maxRetries) {
        stopRetrying();
      }
    }, retryIntervalMs);
  };
};
